<template>
  <div class="d-flex flex-wrap flex-md-nowrap mt-3 mb-3">
    <div class="me-0 me-md-3 mb-3 flex-grow-1 w-100 w-md-auto flex-md-grow-0">
      <button
        @click="navigatePrevious"
        :disabled="isBackButtonDiabled"
        v-show="!isFirst()"
        class="btn btn-red w-100"
      >
        {{ previousButtonText() }}
      </button>
    </div>
    <div class="mb-3 ms-md-auto flex-grow-1 w-100 w-md-auto flex-md-grow-0">
      <!-- <div v-if="dnadoProcess === 'EGYEDI'"> -->
      <div>
        <button
          v-if="isProcessUnique"
          @click="confirmUniqueOffer"
          class="btn btn-red w-100"
          :disabled="isUniqueButtonDisabled"
        >
          Egyedi ajánlatot kérek
        </button>
      </div>
      <button
        v-show="isProcessNormal"
        @click="navigateNext"
        class="btn btn-red w-100"
        :disabled="isNextButtonDisabled"
      >
        <!-- <button @click="navigateNext" class="btn btn-red w-100" :disabled="false"> -->
        {{ nextButtonText() }}
      </button>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import {mapFields} from 'vuex-map-fields';
import Swal from 'sweetalert2';
export default {
  props: ['invalid', 'validate'],
  methods: {
    ...mapActions(['verifyPage']),
    ...mapFields({}),
    nextButtonText() {
      if (this.$store.state.page === 1) return 'Tovább az összesítésre';
      // else if (this.$store.state.page === 2) return 'Tovább az összesítésre';
      // else if (this.$store.state.page === 3) return 'Tovább a szerződés adatokra';
      // else if (this.$store.state.page === 4) return 'Tovább az összesítésre';
      else return 'Megkötöm a biztosítást';
    },

    previousButtonText() {
      if (this.$store.state.page === 2) return 'Vissza az adatokra';
      // else if (this.$store.state.page === 3) return 'Vissza a kiegészítőkre';
      // else if (this.$store.state.page === 4) return 'Vissza a kedvezményekre';
      else return 'Vissza a szerződés adatokra';
    },

    isFirst() {
      return this.$store.state.page === 1;
    },
    isNormal() {
      return this.$store.state.pricess === 'NORMAL';
    },
    confirmUniqueOffer() {
      this.$gtm.trackEvent({
        event: 'getuniquequotation-popup', // Event type [default = 'interaction'] (Optional)
        label: 'getuniquequotation-popup',
        transaction_id: this.product_code,
        category: 'Calculator',
        action: 'click',
        page: this.page,
        // merchant_id: this.merchant_id,
        noninteraction: false, // Optional
      });
      Swal.fire({
        icon: 'warning',
        html:
          '<b>Figyelem!</b><br><div>A gomb megnyomásával Ön leadja az igényét az Egyedi ajánlat elkészítésére!<div>',
        showCloseButton: true,
        showConfirmButton: true,
        showDenyButton: true,
        denyButtonText: 'Mégsem',
        confirmButtonText: 'Ajánlatot kérek',
        customClass: {
          content: 'text-align-center',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.uniqueOffer();
        }
      });
    },
    confirmNormalOffer() {
      this.$gtm.trackEvent({
        event: 'quotation-popup', // Event type [default = 'interaction'] (Optional)
        label: 'quotation-popup',
        transaction_id: this.product_code,
        category: 'Calculator',
        action: 'click',
        page: this.page,
        // merchant_id: this.merchant_id,
        noninteraction: false, // Optional
      });
      Swal.fire({
        icon: 'warning',
        html:
          '<b>Figyelem!</b><br><div>A gomb megnyomásával Ön leadja igényét a biztosítási szerződés megkötésére!<div>',
        showCloseButton: true,
        showConfirmButton: true,
        showDenyButton: true,
        denyButtonText: 'Mégsem',
        confirmButtonText: 'Megkötöm',
        customClass: {
          content: 'text-align-center',
        },
      }).then((result) => {
        if (result.isConfirmed) {
          this.normalOffer();
        }
      });
    },
    uniqueOffer() {
      this.$gtm.trackEvent({
        event: 'getuniquequotation-finalize', // Event type [default = 'interaction'] (Optional)
        label: 'getuniquequotation-finalize',
        transaction_id: this.product_code,
        category: 'Calculator',
        action: 'click',
        page: this.page,
        // merchant_id: this.merchant_id,
        currency: 'HUF',
        noninteraction: false, // Optional
      });
      this.$store.commit('setProcess', 'EGYEDI');
      this.$store.commit('setCompanyData', {name: 'optenFinanceOk', value: 0});
      if (this.$store.state.page === 1) {
        this.$store.dispatch('verifyPage', 6);
      }
      if (this.$store.state.page === 2) {
        this.$store.dispatch('verifyPage', 2);
      }
    },
    normalOffer() {
      this.$gtm.trackEvent({
        event: 'purchase', // Event type [default = 'interaction'] (Optional)
        label: 'purchase',
        transaction_id: this.product_code,
        category: 'Calculator',
        action: 'click',
        page: this.page,
        value: this.premium,
        shipping: 0,
        currency: 'HUF',
        coupon: '',
        noninteraction: false, // Optional
      });
      this.verifyPage(6);
      this.$store.commit('setFormSubmitLoading', true);
    },

    async navigateNext() {
      await this.validate();

      if (this.invalid) return;
      if (this.$store.state.page < 5) {
        this.$gtm.trackEvent({
          event: this.buttonEventName, // Event type [default = 'interaction'] (Optional)
          category: 'Calculator',
          action: 'click',
          label: this.buttonEventName,
          value: 5000,
          page: this.page,
          noninteraction: false, // Optional
        });
      }
      if (this.$store.state.page === 2) {
        // if (!this.$store.state.canProceedToNextPage || this.invalid) return;
        // this.$gtm.trackEvent({
        //   event: this.buttonEventName, // Event type [default = 'interaction'] (Optional)
        //   transaction_id: this.$store.state.product_code,
        //   value: this.$store.state.kieg_emelt_eves_dij,
        //   discount: this.$store.getters.getDiscountSum, //Ez ne negatív szám éegyen *-1
        //   currency: 'HUF',
        //   coupon: this.$store.state.couponCode,
        //   category: 'Calculator',
        //   action: 'click',
        //   label: 'purchase',
        //   noninteraction: false, // Optional
        //   main_buildings_details: this.$store.getters.getMainBuildingDetails('P002'),
        //   side_buildings_details: this.$store.getters.getSideBuildingsDetails('P017'),
        //   items: this.$store.getters.getRisks,
        // });
        // this.verifyPage(6);
        // this.$store.commit('setFormSubmitLoading', true);
        this.confirmNormalOffer();
      } else {
        try {
          const {data: result} = await this.verifyPage(this.$store.state.page);

          if (
            result?.fieldErrors?.length <= 0 &&
            result?.generalErrors?.length <= 0 &&
            !this.invalid
          ) {
            this.$store.commit('incrementPage');
          }
        } catch (e) {
          console.error(e);
        }
      }
    },

    navigatePrevious() {
      this.$store.commit('decrementPage');
    },
  },
  computed: {
    isBackButtonDiabled() {
      return this.$store.state.isBackButtonDisabled;
    },
    isNextButtonDisabled() {
      if (this.merchant_id === '7006600368' && this.page === 2) return true;
      return this.invalid;
    },
    isUniqueButtonDisabled() {
      if (this.$store.state.page === 1) {
        return this.invalid;
      } else {
        return false;
      }
    },
    isProcessNormal() {
      let statementsAccepted =
        this.$store.state.statements.kar &&
        this.$store.state.statements.szerzodes &&
        this.$store.state.statements.iparag &&
        this.$store.state.statements.amerika &&
        this.$store.state.statements.oroszorszag;

      let page = this.$store.state.page;
      // console.log('Process:' + this.$store.state.process);
      // console.log('page:' + page);
      if (this.$store.state.process == 'NORMAL' && page === 1) {
        return true;
      } else if (this.$store.state.process == 'NORMAL' && page === 2) {
        return true;
      }
      return false;
      // } else if (this.$store.state.process == 'NORMAL' && page === 2 && statementsAccepted) {
      //   return true;
      // } else if (this.$store.state.process == 'NORMAL' && page === 3) {
      //   return true;
      // }
    },
    isProcessUnique() {
      let statementsAccepted =
        this.$store.state.statements.kar &&
        this.$store.state.statements.szerzodes &&
        this.$store.state.statements.iparag &&
        this.$store.state.statements.amerika &&
        this.$store.state.statements.oroszorszag;

      let page = this.$store.state.page;
      // console.log('Process:' + this.$store.state.process);
      if (this.$store.state.process == 'EGYEDI') {
        return true;
      }
      // } else if (page === 2 && !statementsAccepted) {
      //   return true;
      // }
    },
    buttonEventName() {
      if (this.$store.state.page === 1) return 'summarydata-next-click';
      // if (this.$store.state.page === 2) return 'paymentSelection-next-click';
      // if (this.$store.state.page === 3) return 'contractualData-next-click';
      // if (this.$store.state.page === 4) return 'contractualSumary-next-click';
      // if (this.$store.state.page === 5) return 'transaction-next-click';
    },
    AllStatementsAccepted() {
      return (
        this.$store.state.statements.kar &&
        this.$store.state.statements.szerzodes &&
        this.$store.state.statements.iparag &&
        this.$store.state.statements.amerika &&
        this.$store.state.statements.oroszorszag
      );
    },
    ...mapFields(['generalInfo.chosenPackage', 'merchant_id', 'page', 'product_code', 'premium']),
  },
};
</script>

<style lang="scss">
@media only screen and (min-width: 768px) {
  .w-md-auto {
    max-width: fit-content !important;
    width: auto !important;
  }
}
</style>
